import { FETCH_CHOOSE_CARRIER_SUCCESS, FETCH_CHOOSE_CARRIER_REQUEST, UPDATE_CHOOSE_CARRIER_REQUEST } from "@/redux/actions";
const initialState = {
    data: "",
    loading: false,
    error: null,
};
const chooseCarrierReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CHOOSE_CARRIER_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_CHOOSE_CARRIER_REQUEST:
            return Object.assign({}, state);
        case UPDATE_CHOOSE_CARRIER_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload });
        default:
            return state;
    }
};
export default chooseCarrierReducer;
